import type { MapData } from "../types";
import { loadNaturalEarthAdm0 } from "./loadNaturalEarthAdm0";
import type { NaturalEarthProps } from "./loadNaturalEarthAdm0";

export type ContinentKey =
  | "north-america"
  | "south-america"
  | "africa"
  | "oceania"
  | "asia";

const CONTINENT_LABELS: Record<ContinentKey, string> = {
  "north-america": "North America",
  "south-america": "South America",
  africa: "Africa",
  oceania: "Oceania",
  asia: "Asia",
};

export async function loadContinentAdm0(
  continent: ContinentKey,
): Promise<MapData> {
  const continentLabel = CONTINENT_LABELS[continent];
  return loadNaturalEarthAdm0(
    (props: NaturalEarthProps) => props.CONTINENT === continentLabel,
  );
}
